import React from 'react';

const LoadingState: React.FC = () => (
  <div role="status" aria-live="polite">Loading hospitals...</div>
);

export default LoadingState;